/* global ym */
import vars from '../helpers';

export const yandexNumberId = 95849282;

let timer15;
let timers = [];
const clienLinks = ['yandex.ru/adv/'];

function isClientLink(href) {
	let value = false;

	clienLinks.forEach((link) => {
		if (href.indexOf(link) >= 0) {
			value = true;
		}
	});

	return value;
};

function clearText(text) {
	return text.toString().trim().replace(/\s+/g, ' ');
};

function virtualHit(path) {
	ym(yandexNumberId, 'hit', path);
}

vars.$document
	.on('page-enter', (e, namespace) => {
		if (namespace) {
			virtualHit(window.location.pathname + window.location.hash + location.search);
		}
	});

jQuery.scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		// // console.log(data.eventLabel)
		ym(yandexNumberId, 'reachGoal', 'scroll depth', {
			'scroll depth': {
				[data.eventLabel]: document.location.href,
			},
		});
	},
});

function spentOnPageTime() {
	let title = $('.page').data('analytics');

	setTimeout(function () {
		title = $('.page').data('analytics');
	},10)

	const times = [
		{
			time: 30000,
			name: '30_sec',
		},
		{
			time: 60000,
			name: '1_min',
		},
		{
			time: 120000,
			name: '2_min',
		},
		{
			time: 300000,
			name: '5_min',
		},
	]

	timers.forEach(el => {
		clearTimeout(el)
	})

	times.forEach(el => {
		timers.push(setTimeout(() => {
			ym(yandexNumberId, 'reachGoal', el.name, {
				[title]: el.name
			});

			// console.log(el.name)
		}, el.time));
	})
}

function spentOnPage15sec() {
	clearTimeout(timer15);

	timer15 = setTimeout(() => {
		ga('send', 'event', 'page', 'spent_on_page_15_sec');

		ym(yandexNumberId, 'reachGoal', 'spent_on_page_15_sec', {
			spent_on_page_15_sec: true,
		});

		// console.log('15')
	}, 15000);
}

function init() {
	spentOnPage15sec();
	spentOnPageTime();

	scrollDepth.reset()

	// header
	$('.js-header-logo-partner').on('click', () => {
		let url = document.location.href;

		ga('send', 'event', 'client link', 'click');

		ym(yandexNumberId, 'reachGoal', 'client link', {
			'client link': {
				'logo header': url,
			},
		});
	});

	$('.js-header-logo-rbc').on('click', () => {
		let url = document.location.href;

		ym(yandexNumberId, 'reachGoal', 'rbc_logo_header_click', {
			rbc_logo_header_click: url,
		});
	});

	// main page
	$('.home__list a').on('click', (e) => {
		const name = e.currentTarget.querySelector('.card__title').textContent

		ym(yandexNumberId, 'reachGoal', 'main material click', {
			'main material click': name
		});
	});

	// articles
	$('.article__main a').on('click', (e) => {
		const name = clearText(e.currentTarget.textContent);
		let url = document.location.href;

		if (isClientLink(e.currentTarget.getAttribute('href'))) {
			ga("send", "event", "client link", "click");

			ym(yandexNumberId, 'reachGoal', 'client link', {
				'client link': {
					'article text link': {
						[name]: url,
					},
				},
			});
		} else {
			ym(yandexNumberId, 'reachGoal', 'text link click', {
				'text link click': {
					article: {
						[name]: url,
					},
				},
			});
		}
	});

	$('.article__footer [data-social]').on('click', (e) => {
		let social = $(e.currentTarget).data('social');
		let url = document.location.href;

		// console.log('share')
		ym(yandexNumberId, 'reachGoal', 'share', {
			share: {
				article: {
					[social]: url,
				},
			},
		});
	});

	$('.read-also a').on('click', (e) => {
		let name = e.currentTarget.dataset.name;
		let place = e.currentTarget.dataset.type;
		let url = document.location.href;

		// console.log(name, place)

		ym(yandexNumberId, 'reachGoal' ,'see also event', {
			'see also event': {
				[`article ${place}`]: {
					[name]: url
				}
			}
		});
	});


	// sharings
	$('.footer [data-social]').on('click', (e) => {
		let social = $(e.currentTarget).data('social');
		let url = document.location.href;

		ym(yandexNumberId, 'reachGoal', 'share', {
			share: {
				'project share': {
					[social]: url,
				},
			},
		});
	});

	// $('.lead__button').on('click', () => {
	// 	ym(yandexNumberId, 'reachGoal' ,'go to article', {
	// 		'go to article': 'true',
	// 	});
	// });

	// $('.article .section__text a, .article section__title a, .article .card__text a, .article card__title a').on('click', (e) => {
	// 	const name = clearText(e.currentTarget.textContent);
	// 	let url = document.location.href;

	// 	if (isClientLink(e.currentTarget.getAttribute('href'))) {
	// 		ga('send', 'event', 'client link', 'click');

	// 		ym(yandexNumberId, 'reachGoal', 'client link', {
	// 			'client link': {
	// 				'article text link': {
	// 					[name]: url,
	// 				},
	// 			},
	// 		});
	// 	} else {
	// 		ym(yandexNumberId, 'reachGoal', 'text link click', {
	// 			'text link click': {
	// 				article: {
	// 					[name]: url,
	// 				},
	// 			},
	// 		});
	// 	}
	// });

	// $('.js-banner-button').on('click', (e) => {
	// 	let $banner = $(e.currentTarget).closest('.js-banner');
	// 	let type = $banner.data('type');
	// 	let name = $banner.data('name');
	// 	let url = document.location.href;

	// 	ga('send', 'event', 'client link', 'click');

	// 	ym(yandexNumberId, 'reachGoal', 'client link', {
	// 		'client link': {
	// 			'banner click': {
	// 				[`${type} banner - ${name}`]: url,
	// 			},
	// 		},
	// 	});
	// });

	// const $showOnScrollElements = $('.js-banner');

	// const showElementsOnScroll = () => {
	// 	const scrollTop = vars.$window.scrollTop();
	// 	const scrollBottom = scrollTop + innerHeight;

	// 	$showOnScrollElements
	// 		.filter(':visible')
	// 		.each((index, element) => {
	// 			const $element = $(element);

	// 			const elementOffsetTop = $element.offset().top;
	// 			const elementOffsetBottom = elementOffsetTop + $element.outerHeight();

	// 			if (scrollBottom >= elementOffsetTop && scrollTop <= elementOffsetBottom && !$element.data('showed')) {
	// 				$element.data('showed', true);

	// 				if ($element.hasClass('js-banner')) {
	// 					let type = $element.data('type');
	// 					let name = $element.data('name');
	// 					let url = document.location.href;

	// 					ym(yandexNumberId, 'reachGoal', 'banner show', {
	// 						'banner show': {
	// 							[`${type} banner - ${name}`]: url,
	// 						},
	// 					});
	// 				}
	// 			}
	// 		});
	// };

	// $showOnScrollElements.data('showed', false);

	// vars.$window.on('scroll', showElementsOnScroll);
}

function destroy() {
	scrolDepth.destroy();
}

export default {
	init,
	destroy,
	spentOnPage15sec,
};
